/* tslint:disable */
/* eslint-disable */
/**
 * Immutable X API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0
 * Contact: support@immutable.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { EncodeAssetTokenData } from './encode-asset-token-data';

/**
 * 
 * @export
 * @interface EncodeAssetRequestToken
 */
export interface EncodeAssetRequestToken {
    /**
     * 
     * @type {EncodeAssetTokenData}
     * @memberof EncodeAssetRequestToken
     */
    'data'?: EncodeAssetTokenData;
    /**
     * The type of the token to be encoded
     * @type {string}
     * @memberof EncodeAssetRequestToken
     */
    'type'?: EncodeAssetRequestTokenTypeEnum;
}

export const EncodeAssetRequestTokenTypeEnum = {
    Eth: 'ETH',
    Erc20: 'ERC20',
    Erc721: 'ERC721'
} as const;

export type EncodeAssetRequestTokenTypeEnum = typeof EncodeAssetRequestTokenTypeEnum[keyof typeof EncodeAssetRequestTokenTypeEnum];


